let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iLKnx")).then(() => parcelRequire('aIWaO'));